/** Shared copy + imagery for Industries page (IndustriesCardStack — dark row layout). */
const IMG = {
    healthcare: '/assets/images/about/industries.jpeg',
    cyber: '/assets/images/about/cyber.jpeg',
    about: '/assets/images/about/about.jpg',
    content: '/assets/images/about/content.jpg',
    callcenter: '/assets/images/about/call%20center.jpg',
}

export const industries = [
    {
        num: '01',
        title: 'Healthcare',
        image: IMG.healthcare,
        tags: 'Medical Billing | Revenue Cycle Management | Call Center | Cybersecurity | Content',
        paras: [
            'Where TechDigit was born and where our deepest expertise lives. Primary care, cardiology, mental health, urgent care, multi-specialty groups, behavioral health, hospital systems: we\'ve worked across every major specialty and solved every major operational problem healthcare providers face.',
            'Denied claims are draining revenue. Patient calls are going unanswered. Data vulnerabilities that keep compliance officers awake at night. HIPAA-compliant content that actually educates patients. This is our home ground.',
        ],
        cta: 'Explore Healthcare Services',
        to: '#',
    },
    {
        num: '02',
        title: 'Financial Services & Fintech',
        image: IMG.cyber,
        tags: 'Cybersecurity | Professional Content',
        paras: [
            'Financial organizations carry some of the most targeted data on earth. Regulatory exposure is enormous. One breach doesn\'t just cost recovery money; it costs client trust that took years to build.',
            'We deliver security programs built to meet the compliance requirements that financial firms actually face, alongside whitepapers, investment thought leadership and buyer\'s guides that speak credibly to CFOs, compliance officers and sophisticated investors.',
        ],
        cta: 'Explore Financial Services Solutions',
        to: '#',
    },
    {
        num: '03',
        title: 'Technology & SaaS',
        image: IMG.about,
        tags: 'Cybersecurity | Technical Content | Developer Documentation',
        paras: [
            'Technology companies are expected to be the most secure organizations in any room—and simultaneously the fastest-moving. We build security that scales with rapid growth and protects the cloud environments and application layers SaaS businesses depend on.',
            'For tech companies building thought leadership, we write technical whitepapers, platform buyer\'s guides, API documentation and annual benchmark reports that hold up under scrutiny from the most demanding technical audiences.',
        ],
        cta: 'Explore Technology Solutions',
        to: '#',
    },
    {
        num: '04',
        title: 'Publishing, Authors & Creative Industries',
        image: IMG.content,
        tags: 'Ebook Writing | Ghostwriting | Non-Fiction | Fiction | Self-Help | Business Books',
        paras: [
            'Not every great book gets written by the person whose name is on the cover. Not every expert has the time or the inclination to stare at a blank page for six months.',
            'TechDigit\'s content team works with authors, thought leaders, coaches, consultants and publishers across fiction, non-fiction, self-help, business, memoirs and beyond. Whether you have a fully developed idea that needs a skilled writer or a rough manuscript that needs a complete transformation, we deliver publication-ready work, entirely under your name, with your voice and on your timeline.',
        ],
        cta: 'Explore Writing & Publishing Services',
        to: '#',
    },
    {
        num: '05',
        title: 'Legal & Professional Services',
        image: IMG.healthcare,
        tags: 'Cybersecurity | Thought Leadership Content',
        paras: [
            'Law firms handle confidential information that cannot be compromised under any circumstances. A breach doesn\'t just cost money — it can end careers and close practices. We build security programs around the strict access-control and data-protection standards that legal environments require.',
            'For professional services firms competing on expertise, we produce methodology whitepapers, industry outlook reports, and long-form content that makes the right people see your firm as the obvious choice before the first meeting is even scheduled.',
        ],
        cta: 'Explore Professional Services Solutions',
        to: '#',
    },
    {
        num: '06',
        title: 'Education, Coaching & Personal Development',
        image: IMG.callcenter,
        tags: 'Ebook Writing | Course Content | Guides | Workbooks',
        paras: [
            'Knowledge is your product. The quality of its packaging determines whether it gets taken seriously or scrolled past.',
            'TechDigit produces professional ebooks, course companion guides, workbooks, and educational content for coaches, educators, online course creators and personal development brands. Content that positions you as the authority your audience already believes you are, written with the depth and clarity that converts readers into clients.',
        ],
        cta: 'Explore Education & Coaching Content',
        to: '#',
    },
    {
        num: '07',
        title: 'Manufacturing & Industrial',
        image: IMG.cyber,
        tags: 'Cybersecurity | Technical Documentation | Compliance Content',
        paras: [
            'Operational environments are increasingly targeted by cyberattacks that most traditional security programs weren\'t designed to handle. We build security that protects both digital infrastructure and operational systems without disrupting production.',
            'For manufacturers and industrial companies, we also produce technical documentation, equipment buyer\'s guides, safety compliance content, and industry reports for audiences that expect precision over polish.',
        ],
        cta: 'Explore Manufacturing Solutions',
        to: '#',
    },
    {
        num: '08',
        title: 'Retail, E-Commerce & Consumer Brands',
        image: IMG.content,
        tags: 'Cybersecurity | Call Center | Brand Content',
        paras: [
            'Retail businesses handle high volumes of customer data and payment information year-round—not just during peak seasons. We secure what you\'ve built and keep your customer-facing systems running when demand spikes and attackers circle.',
            'For consumer brands, our call center service handles customer support, order management, and billing inquiries at scale—and our content team produces brand ebooks and buyer\'s guides that turn browsers into buyers.',
        ],
        cta: 'Explore Retail Solutions',
        to: '#',
    },
]
